/**
 * System reducer
 *
 * @author Mamontov Andrey, 11/2023
 */
import * as systemAction from '../actions/system';

export const getConnectedStatus = (state: SystemState) => state.connectedStatus;
export const getDisconnectedCounter = (state: SystemState) => state.disconnectedCounter;


export interface SystemState {
  connectedStatus: boolean;
  disconnectedCounter: number;
}

export const initialState: SystemState = {
  connectedStatus: true,
  disconnectedCounter: 0
};

export function reducer (state = initialState,
                         action: systemAction.Action): any {
  switch (action.type) {
    case systemAction.SET_CONNECTED_STATUS: {
       return {
        ...state,
         connectedStatus: action.payload
      };
    }
      case systemAction.SET_DISCONNECTED_COUNTER: {
          return {
              ...state,
              disconnectedCounter: action.payload
          };
      }
    default:
      return state;
  }
}
